import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import Grid, { GridSpacing } from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Box from '@mui/material/Box';
import LoadingButton from '@mui/lab/LoadingButton';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles, createStyles } from '@material-ui/core/styles';

import PhaseCurrentCheckBoxList, { PhaseCurrentCheckBoxData } from './PhaseCurrentCheckBoxList';
import PhaseCurrentSelectItem, { PhaseCurrentSelectData, InitDataType } from './PhaseCurrentSelectItem';
import PhaseCurrentChart from './PhaseCurrentChart';
import { GetLatesTime } from './PhaseCurrent';
import PhaseCurrentButtonList from './PhaseCurrentButtonList';
import { PH_CUR_GROUP_SET } from '../../../function/GroupDataModel';
import { GetNameDevSetList, NAME_DEV_SET } from '../../../function/NameDevSetModel';
import RangeInputNumberLimit from '../../molecules/Range/RangeInputNumberLimit';
import { useTranslation } from 'react-i18next';
import MessageDialog, { MessageDialogResponse } from '../../atoms/Dialog/MessageDialog';
import { useModal } from '../../../function/useModal';

const useStyles = makeStyles(
  createStyles({
    responsiveContainer: {
      minHeight: 'calc(100vh - 346px)',
      maxHeight: 'calc(100vh - 346px)',
    },
    paper: {
      background: '#FFFFEE',
    },
    buttonStyle: {
      Width: '180px',
      Height: '45px',
    },
    flexBox: {
      display: 'flex',
      eight: '45px',
      alignItems: 'flex-end',
    },
    flexBoxItem: {
      padding: '0px 50px 0px 0;',
      margin: '1px' /* 外側の余白 */,
    },
  })
);

/**
 * 時間範囲選択格納タイプ
 */
export type SelectMsecondType = {
  maxSec: number;
  minSec: number;
};

type Props = {
  location: { state: PH_CUR_GROUP_SET };
};

const PhaseCurrentPage: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [selectMSecond, setSelectMSecond] = React.useState<SelectMsecondType>({
    maxSec: 100,
    minSec: 0,
  });
  const [initData, setInitData] = React.useState<InitDataType>({
    selectData: {
      devIndex: '0',
      selectTime: '',
      selectDay: dayjs(new Date()).format('YYYY-MM-DD'),
      maxSec: 100,
      minSec: 0,
    },
    nameDevList: [],
  });
  const [selectData, setSelectData] = useState<PhaseCurrentSelectData>({
    devIndex: '0',
    selectTime: '',
    selectDay: dayjs(new Date()).format('YYYY-MM-DD'),
    maxSec: 100,
    minSec: 0,
  });
  const [checkBoxData, setCheckBoxData] = useState<PhaseCurrentCheckBoxData>({
    isRDisp: true,
    isSDisp: true,
    isTDisp: true,
    isPileup: false,
    isDCRemoval: true,
  });
  const [chartUpdate, setChartUpdate] = React.useState<string>('');

  const [dlgmsg, setDlgmsg] = useState<string>('');
  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();

  const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;

  const handleLoadingStateChange = (value: boolean): void => setLoading(value);

  const handleSelectDataChange = (data: PhaseCurrentSelectData): void => {
    console.debug(['PhaseCurrentPage-handleSelectDataChange , data', data]);
    setSelectData({ ...data });
  };

  const handleCheckBoxDataChange = (data: PhaseCurrentCheckBoxData): void => {
    setCheckBoxData({ ...data });
  };

  const handleChartUpdate = (): void => {
    console.debug(['handleChartUpdate - selectData', selectData]);
    if (selectData.selectTime != '') {
      setChartUpdate(dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'));
    } else {
      setDlgmsg(t('PhaseCurrentPage.計測ファイル日時を指定してください', '計測ファイル日時を指定してください。'));
      actMsgDlg.open();
    }
  };

  const handleSelectSecDataChagne = (min: number, max: number) => {
    console.debug(`min=${min},max=${max}`);
    setSelectMSecond({ maxSec: max, minSec: min });
  };

  useEffect(() => {
    var devindex = props.location.state != undefined ? props.location.state.DEV_INDEX : 1;
    GetNameDevSetList().then((ret) => {
      console.debug(['useEffect -- GetNameDevSetList ret', ret]);
      const nameDevSets = ret.filter((output, index) => {
        return output.EST === 1;
      });

      const indexCheck = nameDevSets.find((r) => r.DEV_INDEX == devindex);
      console.debug(['useEffect -- indexCheck', indexCheck]);
      if (indexCheck !== undefined) {
        GetLatesTime(String(devindex)).then((ret) => {
          console.debug(['useEffect -- GetLatesTime ret', ret]);
          if (dayjs(new Date(ret)).format('YYYY-MM-DD') == '1-01-01') {
            var tmp = selectData;
            tmp.devIndex = String(devindex);
            tmp.selectTime = '';
            tmp.selectDay = dayjs(new Date()).format('YYYY-MM-DD');
            console.debug(['PhaseCurrentPage-handleSelectDataChange , tmp 1-01-01', tmp]);
            setSelectData({ ...tmp });
            //データが見つからなかった、画面表示の更新はしなくてもいい
            //setInitData({ selectData: tmp, nameDevList: nameDevSets });
            //setChartUpdate(dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'));
          } else {
            var tmp = selectData;
            tmp.devIndex = String(devindex);
            tmp.selectTime = dayjs(new Date(ret)).format('HH:mm:ss');
            tmp.selectDay = dayjs(new Date(ret)).format('YYYY-MM-DD');

            console.debug(['PhaseCurrentPage-handleSelectDataChange , tmp HH:mm:ss', tmp]);
            setSelectData({ ...tmp });
            setInitData({ selectData: tmp, nameDevList: nameDevSets });
            setChartUpdate(dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'));
          }
        });
      }
      else {
        var tmp = selectData;
        tmp.devIndex = String(nameDevSets[0].DEV_INDEX);
        tmp.selectTime = '';
        tmp.selectDay = dayjs(new Date()).format('YYYY-MM-DD');
        console.debug(['PhaseCurrentPage-target DEV_INDEX EST==0 ', tmp]);
        setSelectData({ ...tmp });
        setInitData({ selectData: tmp, nameDevList: nameDevSets });
      }

    });
  }, []);

  //console.debug(['- 画面描画開始 -', selectMSecond, chartUpdate, ]);
  return (
    <Grid container justify="flex-start" spacing={1} direction="row" style={{ margin: 0 }}>
      <Grid item xs={12}>
        <div className={classes.flexBox}>
          <div className={classes.flexBoxItem}>
            <PhaseCurrentSelectItem
              initData={initData}
              selectData={selectData}
              onSelectDataChangeEvent={handleSelectDataChange}
            />
          </div>
          <div className={classes.flexBoxItem}>
            <LoadingButton
              style={{ width: '100px' }}
              loading={loading}
              loadingPosition="start"
              variant="contained"
              startIcon={<SearchIcon />}
              onClick={handleChartUpdate}
            >
              {t('PhaseCurrentPage.表示', '表示')}
            </LoadingButton>
          </div>
          <div className={classes.flexBoxItem}>
            <PhaseCurrentCheckBoxList selectData={checkBoxData} onSelectDataChangeEvent={handleCheckBoxDataChange} />
          </div>
          <div className={classes.flexBoxItem}>
            <RangeInputNumberLimit
              textBoxWidth={'70px'}
              limitValue={1000}
              label={t('PhaseCurrentPage.時間軸範囲', '時間軸範囲')}
              minValue={selectMSecond.minSec}
              maxValue={selectMSecond.maxSec}
              minValueLimit={0}
              maxValueLimit={31459}
              onChange={handleSelectSecDataChagne}
            />
          </div>
        </div>
      </Grid>
      <Grid item xs={12}>
        <PhaseCurrentChart
          selectMSecondData={selectMSecond}
          checkBoxData={checkBoxData}
          selectData={selectData}
          chartUpDate={chartUpdate}
          chartContainerStyle={classes.responsiveContainer}
          updateLoadginState={handleLoadingStateChange}
        />
      </Grid>
      <Grid item xs={12}>
        <PhaseCurrentButtonList phaseCurrentSelectData={selectData} />
      </Grid>
      {msgdlg}
    </Grid>
  );
};

export default PhaseCurrentPage;
